export default __webpack_public_path__ + "static/diferencial-img-1-1ba68ff60011c97ede62a0d61d69e59a.png";